<template>
  <div class="CategroyEnter" :style="boxStyle">
    <div class="icon_list_box icon_five_box">
        <div class="icon_content"
            v-for="(item, index) in detailData.cateList"
            :key="index">
            <div class="icon_img">
                <img :src="item.logo" class="icon_image"/>
            </div>
            <div class="icon_name">{{item.name}}</div>
        </div>
    </div>
  </div>
</template>

<script>

import mixins from '../mixins/mixins'
export default {
  name: 'CategroyEnter',
  mixins: [mixins],
  props: {
  },
  components: {},
  data() {
    return {
        detailData: {
            cateList: []
        },
        pattern: {},
    }
  },
  watch: {
  },
  computed: {
    boxStyle(){
      return {
        "margin-left": (this.pattern.margin || 0) + 'px',
        "margin-right": (this.pattern.margin || 0) + 'px',
      }
    },
  },
  methods: {
    async init() {
        this.detailData = await this._filter(this.itemData)
        this.pattern = this.detailData.pattern || {}
        console.log("CategroyEnter----------this.detailData");
        console.log(this.detailData);
    }
  },
  async mounted() {
    
  }
}
</script>
<style lang="scss" scoped>
.icon_list_box.icon_five_box .icon_content {
    .icon_image,
    .icon_img{
        height: 42px;
        border-radius: 21px;
        overflow: hidden;
    }
}
.icon_list_box {
    overflow: hidden;
}
.icon_list_box {
    background-color: #fff;
    position: relative;
    padding:9px 10px;
    height: 75px;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    &:nth-child(2){
        padding-top:10px;
    }
    .icon_lists {
        display:flex;
        justify-content:space-between;
        .icon_list {
            display:inline-block;
            .icon_content {
                text-align: center;
                img {
                    width:42px;
                    height:42px;
                    border-radius:42px;
                }
                .icon_name {
                    font-size:12px;
                    color:#333;
                    margin-top:4px;
                }
            }
        }
    }
    .more_arrow {
        position:absolute;
        right:5px;
        // top:64rpx;
        top:14px;
        color:#dedede;
    }
    &.icon_five_box {
        .icon_content {
            text-align: center;
            display: inline-block;
            width: 25%;
            .icon_image {
                width:42px;
                height:42px;
            }
            .icon_name {
                font-size:12px;
                color:#333;
                margin-top:4px;
            }
        }
    }
}
</style>

